// extracted by mini-css-extract-plugin
export default {"box":"container_box__5yaM4","s":"container_s__YV1Ue","empty":"container_empty__K45R0","c":"container_c__dtM55","h":"container_h__mg1T6"};